import React from "react";

const ProjectParticularsContext = React.createContext();

export default ProjectParticularsContext;
